import { useProduct } from '@components/pages/Product/components/ProductPageComponents/ProductPageComponents';
import CmsBenefits from '@components/components/CmsComponents/components/CmsBenefits/CmsBenefits';
import styles from '@components/components/CmsComponents/components/CmsProductBenefits/CmsProductBenefits.module.scss';
import { Content } from '@wienenergiegithub/ui-next';
import React from 'react';

const ProductBenefits = () => {
  // data gets provided by the ProductContext, which is different for Lagacy products vs. products from Tarifwelt NEU
  const product = useProduct();
  const items = product?.data?.boni ?? [];

  const legalText = product?.data?.boni_legal_text ?? '';
  const isList = product?.data?.display_as_list;
  return (
    <>
      <CmsBenefits isList={isList} items={items} />
      <Content className={styles.legalText}>{legalText}</Content>
    </>
  );
};

export default ProductBenefits;
